// src/layout/customer/CustomerBanner.jsx
import React, { useState, useEffect } from "react";
import CustomerDetails from "./CustomerDetails/CustomerDetails";
import CustomerAddress from "./CustomerDetails/CustomerAddress";
// CORRECTED IMPORT PATH:
import useProfileStore from "../../store/customer/useProfileStore";

const CustomerBanner = ({
  // coverImageUrl, // This prop might not be used if not available for customer
  profileImageUrl: initialProfileImageUrl, // Renamed to avoid conflict
  name,
  role,
  location,
  progress,
}) => {
  const [activeTab, setActiveTab] = useState("profile");
  const {
    profile: customerProfile,
    updateProfile,
    fetchProfile,
  } = useProfileStore(); // Get customer profile and update function

  return (
    <>
      <div className="bg-gray-100 overflow-hidden shadow rounded-2xl text-sm">
        <div className="relative px-5 py-2 bg-white h-[100px]">
          {/* Removed profile image section, adjust layout if needed */}
          <div className="ml-4 pt-4">
            {" "}
            {/* Adjusted margin and padding */}
            <h2 className="text-base font-semibold">
              {name || "Customer Name"}
            </h2>
            <p className="text-gray-600 flex items-center space-x-2 text-sm">
              <span>{role || "Customer"}</span>
              {location && (
                <>
                  <span>•</span>
                  <span>{location}</span>
                </>
              )}
            </p>
            <div className="mt-2">
              <div className="h-1.5 bg-gray-200 rounded-full w-32">
                <div
                  className="h-full bg-blue-500 rounded-full"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mt-1">{progress}% Complete</p>
            </div>
          </div>
        </div>

        <div className="relative bg-white pt-2">
          <ul className="flex justify-start gap-6 text-gray-600 w-full px-4 text-sm">
            <li
              className={`cursor-pointer px-4 py-2 h-full ${activeTab === "profile" ? "bg-gray-300 font-bold" : "hover:bg-[#E0E0E0]"
                }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("profile")}
            >
              Profile
            </li>
            <li
              className={`cursor-pointer px-4 py-2 h-full ${activeTab === "address" ? "bg-gray-300 font-bold" : "hover:bg-[#E0E0E0]"
                }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("address")}
            >
              Address
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-4 p-4 bg-white shadow-md rounded-2xl text-sm">
        {activeTab === "profile" && <CustomerDetails />}
        {activeTab === "address" && <CustomerAddress />}
      </div>
    </>
  );
};

export default CustomerBanner;
